import { RegenerateAISuggestionsMenuItem } from '@/modules/aiSuggestions/components/RegenerateAISuggestionsMenuItem';
import { useCanEditHouseholdData } from '@/modules/authentication/hooks/useCanEditHouseholdData';
import { useBeneficiaryDesignationSuggestionsContext } from '@/modules/beneficiaryDesignations/contexts/beneficiaryDesignationSuggestions.context';
import { useHouseholdDetailsContext } from '@/modules/household/contexts/householdDetails.context';

interface RegenerateBDSuggestionsV2MenuItemProps {
  /** The retirement / insurance account entity whose BD suggestions regenerate. */
  entityId: string;
}

/**
 * Menu item that manually regenerates beneficiary-designation AI suggestions for
 * a retirement / directly-held-insurance account, mirroring
 * {@link RegenerateDPSuggestionsV2MenuItem} for the death-event DP editor. BD
 * suggestions are `DP_RECIPIENT_V2` rows, so it drives the shared target-scoped
 * mutation with the DP-only option set. Hidden without a household or edit permission.
 */
export function RegenerateBDSuggestionsV2MenuItem({
  entityId,
}: RegenerateBDSuggestionsV2MenuItemProps) {
  const { householdId } = useHouseholdDetailsContext();
  const canEditHouseholdData = useCanEditHouseholdData();
  const { refetch: refetchBDSuggestions } =
    useBeneficiaryDesignationSuggestionsContext();

  if (!householdId || !canEditHouseholdData) {
    return null;
  }

  return (
    <RegenerateAISuggestionsMenuItem
      targetId={entityId}
      householdId={householdId}
      onCompleted={refetchBDSuggestions}
      opts={{
        includeDPSuggestions: true,
        includeDetailsSuggestions: false,
      }}
    />
  );
}
